import {MatchHistoryTable} from "components/MatchHistoryTable";

$(function(){


	if($('#page_mod').length)
	{
		MatchHistoryTable.attachTableEvents($('#page_mod').find('.match_history_container'));
	}

	if($('#page_stats').length)
	{
		$('input[name=username]').usernameAutocomplete();
	}

	let bugsPage = $('#page_bugs');
	if(bugsPage.length)
	{
		bugsPage.on('click', 'a.bug_title', function(e){

		});
		return;
	}
	

});